export const FooterData = [
  {
    linkItem: {
      title: "About Olivela",
      links: [
        {
          link_title: "Our story",
          link_href: "/impact/about-us",
        },
        {
          link_title: "Our impact",
          link_href: "/impact",
        },
        {
          link_title: "Cause partners",
          link_href: "/impact/cause-partners",
        },
        {
          link_title: "Sustainability ",
          link_href: "/impact/sustainability",
        },
      ],
    },
  },
  {
    linkItem: {
      title: "Services",
      links: [
        {
          link_title: "Olivela Rewards",
          link_href: "/rewards",
        },
        {
          link_title: "Jewelry Concierge",
          link_href: "/jewelry-concierge",
        },
        {
          link_title: "Nantucket boutique",
          link_href: "/boutiques",
        },
        {
          link_title: "Personal shopping",
          link_href: "/personal-shopping",
        },
      ],
    },
  },
  {
    linkItem: {
      title: "Customer care",
      links: [
        {
          link_title: "My orders",
          link_href: "/account/orders",
        },
        {
          link_title: "Create return or exchange",
          link_href: `${process.env.LOOPRETURNS_STORE_DOMAIN}`,
        },
        {
          link_title: "Shipping policy",
          link_href: "/faq",
        },
        {
          link_title: "FAQ",
          link_href: "/faq",
        },
      ],
    },
  },
];



export const FooterDataRowTwo = [
  {
    linkItem: {
      title: "Legal",
      links: [
        {
          link_title: "Privacy policy",
          link_href: "/privacy",
        },
        {
          link_title: "Accessibility ",
          link_href: "/accessibility",
        },
        {
          link_title: "Legal",
          link_href: "/legal",
        },
      ],
    },
  },
  {
    linkItem: {
      title: "Partner",
      links: [
        {
          link_title: "Affiliates",
          link_href: "/affiliates",
        },
        {
          link_title: "Stylist Program",
          link_href: "/stylist-program",
        },
      ],
    },
  },
];


